export const sources = {
	avif: "__VITE_ASSET__TX5a1iViCylaCWPFSCQG2w__ 640w, __VITE_ASSET__tgItkVM6JTrfm2CiQnzY5g__ 960w, __VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__ 1280w, __VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__ 1920w",
	webp: "__VITE_ASSET__qZZZ7EOcQU0bnm2SE9d1Ig__ 640w, __VITE_ASSET__0PgJxXqjw$KAl6PgZjQb5g__ 960w, __VITE_ASSET__zOyQqdNGsn0lL_XEFrarVA__ 1280w, __VITE_ASSET__RCaHVq_jCUoWDQWiWLxE3w__ 1920w",
	jpeg: "__VITE_ASSET__U6muqRGa8aHtq8t0c9wAzg__ 640w, __VITE_ASSET__y3WuTrdTs_Si7uYpRddj9w__ 960w, __VITE_ASSET__EsSyonNWXFChOyjfj2S3nw__ 1280w, __VITE_ASSET__07gvO1IvTzTCTyYqp_a5mw__ 1920w"
};
export const img = {
	src: "__VITE_ASSET__07gvO1IvTzTCTyYqp_a5mw__",
	w: 1920,
	h: 1080
};
export default {
	sources: sources,
	img: img
};
